import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import QRCode from 'qrcode';
import { 
  Card, 
  Row, 
  Col, 
  Form, 
  Button, 
  Alert, 
  Spinner, 
  Table,
  Badge,
  Container,
  Modal,
  ProgressBar,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Tabs,
  Tab,
  Toast, 
  ToastContainer,
  Pagination
} from "react-bootstrap";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import mairieLogo from "../../assets/img/image.jpeg";
import axios from "axios";
import {
  ArrowLeft,
  Eye,
  Receipt,
  Cash,
  CheckCircle,
  InfoCircle,
  Person,
  Phone,
  FileText,
  Search,
  XCircle,
  ExclamationTriangle,
  CalendarDate,
  Wallet2,
  CreditCard2Front,
  PhoneVibrate,
  Bank2,
  Calculator,
  CashStack,
  Percent,
  Clock,
  HourglassSplit,
  CashCoin,
  CalendarEvent,
  CalendarX,
  Plus,
  Buildings,
  Envelope,
  GeoAlt,
  Printer,
  CurrencyDollar,
  ArrowRight,
  ChevronDown
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../../constants/api_constants";

// const API_BASE_URL = process.env.REACT_APP_API_URL;
const LOCALITES_ENDPOINT = `${API_BASE_URL}/localites`;
const PAYMENT_ENDPOINT = `${API_BASE_URL}/payments`;

const EcheancesTaxPage = () => {
  const { taxId, contribuableId, activityId } = useParams();
  const navigate = useNavigate();
  const defaultCurrency = sessionStorage.getItem("default_currency") || 'XOF';
  
  // États pour les données
  const [tax, setTax] = useState(null);
  const [contribuable, setContribuable] = useState(null);
  const [periods, setPeriods] = useState([]);

  const [error, setApiError] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usingMockData, setUsingMockData] = useState(false);

  // ==================== ÉTATS POUR LES LOCALITÉS ====================
  const [allLocalites, setAllLocalites] = useState([]);
  const [localiteInfo, setLocaliteInfo] = useState(null);
  const [loadingLocalite, setLoadingLocalite] = useState(false);
  const [agentInfo, setAgentInfo] = useState(null);
  const [loadingAgent, setLoadingAgent] = useState(false);

  // États pour les devises
  const [selectedCurrency, setSelectedCurrency] = useState(defaultCurrency);
  const [availableCurrencies, setAvailableCurrencies] = useState([]);
  const [conversionRates, setConversionRates] = useState({});
  const [loadingCurrencies, setLoadingCurrencies] = useState(false);
  const [filteredByActivity, setFilteredByActivity] = useState(null);
  
  // États pour les échéances triées
  const [overduePeriods, setOverduePeriods] = useState([]);
  const [upcomingPeriods, setUpcomingPeriods] = useState([]);
  const [paidPeriods, setPaidPeriods] = useState([]);
  const [activeTab, setActiveTab] = useState("overdue");
  
  // États pour la sélection et le paiement
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [paymentType, setPaymentType] = useState("full");
  const [amount, setAmount] = useState(0);
  const [transactionRef, setTransactionRef] = useState("");
  const [collecting, setCollecting] = useState(false);
  const [customAmount, setCustomAmount] = useState("");

  // États pour la détection réseau
  const [numeroPaiement, setNumeroPaiement] = useState("");
  const [rechercheLoading, setRechercheLoading] = useState(false);
  const [networkName, setNetworkName] = useState("");
  const [networkLogo, setNetworkLogo] = useState("");
  const [networkCode, setNetworkCode] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [walletsSupplementaires, setWalletsSupplementaires] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");
  const [detectionError, setDetectionError] = useState("");
  
  // États pour les notifications
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [loadingDetails, setLoadingDetails] = useState(false);
  
  // États pour la confirmation
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [activitiesMap, setActivitiesMap] = useState({});
  
  // États pour le filtrage et la pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: 'due_date', direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  
  // États pour les statistiques
  const [stats, setStats] = useState({
    overdueTotal: 0,
    upcomingTotal: 0,
    paidTotal: 0,
    totalAmount: 0,
    totalInitialAmount: 0,
    overdueCount: 0,
    upcomingCount: 0,
    paidCount: 0,
    totalCount: 0
  });

  // États pour les modals de détails et d'impression
  const [showDetailsPeriodModal, setShowDetailsPeriodModal] = useState(false);
  const [selectedDetailPeriod, setSelectedDetailPeriod] = useState(null);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedPrintPeriod, setSelectedPrintPeriod] = useState(null);

  const [activiteFilter, setActiviteFilter] = useState("all");
  const [sousComptesList, setSousComptesList] = useState([]);
  const [activiteMapping, setActiviteMapping] = useState({});
  const [usagerToActiviteMap, setUsagerToActiviteMap] = useState({});

  // ✅ Fonction corrigée - définit les périodes à afficher selon l'onglet actif
  const getCurrentPeriods = () => {
    switch(activeTab) {
      case "overdue":
        return overduePeriods;
      case "upcoming":
        return upcomingPeriods;
      case "paid":
        return paidPeriods;
      default:
        return overduePeriods;
    }
  };

  const fetchUsagerActiviteMapping = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/taxpayers/${contribuableId}/all-taxes`, { 
        headers: getHeaders() 
      });
      
      const mapping = {};
      if (Array.isArray(response.data)) {
        response.data.forEach(tax => {
          const usagerId = tax.usager_contribuable_id;
          const activiteId = tax.activite_contribuable;
          if (usagerId && activiteId) {
            mapping[usagerId] = activiteId;
          }
        });
      }
      setUsagerToActiviteMap(mapping);
      return mapping;
    } catch (error) {
      console.error("Erreur:", error);
      return {};
    }
  };

  const fetchActivitiesMapping = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/activites`, { headers: getHeaders() });
      let activities = [];
      if (response.data && Array.isArray(response.data)) {
        activities = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        activities = response.data.data;
      }
      
      const mapping = {};
      activities.forEach(act => {
        const id = act.id_export;
        const name = act.cat_name && act.cat_name !== 'null' 
          ? `${act.name} - ${act.cat_name}` 
          : act.name;
        mapping[id] = name;
      });
      setActivitiesMap(mapping);
      return mapping;
    } catch (error) {
      console.error("Erreur chargement activités:", error);
      return {};
    }
  };

  const fetchActivitesAndSousComptes = async () => {
    try {
      const activitesResponse = await axios.get(`${API_BASE_URL}/activites?has_tax=yes`, { headers: getHeaders() });
      let activities = [];
      if (activitesResponse.data && Array.isArray(activitesResponse.data)) {
        activities = activitesResponse.data;
      } else if (activitesResponse.data && activitesResponse.data.data && Array.isArray(activitesResponse.data.data)) {
        activities = activitesResponse.data.data;
      }
      
      const mapping = {};
      activities.forEach(act => {
        const id = act.id_export || act.code_category || act.id;
        const name = act.name || act.cat_name || `Activité ${id}`;
        mapping[id] = name;
        if (act.code_category && act.code_category !== id) mapping[act.code_category] = name;
      });
      setActiviteMapping(mapping);
      
      const allTaxesResponse = await axios.get(`${API_BASE_URL}/taxpayers/${contribuableId}/all-taxes`, { headers: getHeaders() });
      
      if (Array.isArray(allTaxesResponse.data)) {
        const sousComptesMap = new Map();
        
        allTaxesResponse.data.forEach(tax => {
          const isMain = tax.is_main_account === true || tax.is_main_account === 1;
          if (!isMain && tax.usager_contribuable_id) {
            const subId = tax.usager_contribuable_id;
            const activiteId = tax.activite_contribuable;
            const activiteNom = mapping[activiteId] || tax.nom_activite || 'Sous-activité';
            
            if (!sousComptesMap.has(subId)) {
              sousComptesMap.set(subId, {
                id: subId,
                nom_contribuable: tax.nom_contribuable || `Activité ${subId}`,
                activite_contribuable: activiteId,
                activite_nom: activiteNom
              });
            }
          }
        });
        
        setSousComptesList(Array.from(sousComptesMap.values()));
      }
    } catch (error) {
      console.error("Erreur chargement activités:", error);
    }
  };

  // ==================== FONCTIONS POUR LES LOCALITÉS ====================

  const fetchAllLocalites = async () => {
    try {
      const response = await axios.get(LOCALITES_ENDPOINT, { headers: getHeaders() });
      let localitesArray = [];
      if (response.data && Array.isArray(response.data)) {
        localitesArray = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        localitesArray = response.data.data;
      }
      setAllLocalites(localitesArray);
      return localitesArray;
    } catch (error) {
      console.error("Erreur chargement localités:", error);
      return [];
    }
  };

  const getParentChain = (localitesList, localiteId, chain = []) => {
    if (!localiteId) return chain;
    
    const current = localitesList.find(l => l.localite_id === localiteId);
    if (!current) return chain;
    
    chain.unshift(current);
    
    if (current.parent_id) {
      return getParentChain(localitesList, current.parent_id, chain);
    }
    
    return chain;
  };

  const extractLocationInfoFromChain = (chain) => {
    let province = null;
    let departement = null;
    let ville = null;
    let commune = null;
    let arrondissement = null;
    let quartier = null;
    let pays = null;
    
    chain.forEach(loc => {
      if (loc.pays_code && !pays) {
        pays = loc.pays_code === "CD" ? "RDC" : loc.pays_code;
      }
      
      switch (loc.type_code) {
        case 1005: if (!province) province = loc.nom; break;
        case 1004: if (!departement) departement = loc.nom; break;
        case 1001: if (!ville) ville = loc.nom; break;
        case 1000: if (!commune) commune = loc.nom; break;
        case 1003: if (!arrondissement) arrondissement = loc.nom; break;
        case 1002: if (!quartier) quartier = loc.nom; break;
        default: break;
      }
    });
    
    if (commune && !ville) {
      ville = commune;
    }
    
    const adresseParts = [];
    if (quartier) adresseParts.push(quartier);
    if (arrondissement) adresseParts.push(arrondissement);
    if (commune) adresseParts.push(commune);
    if (ville) adresseParts.push(ville);
    if (departement) adresseParts.push(departement);
    if (province) adresseParts.push(province);
    
    return {
      province, departement, ville, commune, arrondissement, quartier,
      pays: pays || "RDC",
      adresseComplete: adresseParts.join(', '),
      chaineComplete: chain
    };
  };

  const fetchContribuableLocalite = async (contribuableData) => {
    if (!contribuableData) return;
    
    setLoadingLocalite(true);
    try {
      let localitesData = allLocalites;
      if (localitesData.length === 0) {
        localitesData = await fetchAllLocalites();
      }
      
      const localiteId = contribuableData.localite_id;
      if (localiteId && localitesData.length > 0) {
        const foundLocalite = localitesData.find(l => l.localite_id === localiteId);
        if (foundLocalite) {
          const chain = getParentChain(localitesData, localiteId, []);
          if (chain.length > 0) {
            const locationInfo = extractLocationInfoFromChain(chain);
            setLocaliteInfo(locationInfo);
            return locationInfo;
          }
        }
      }
      
      setLocaliteInfo({
        adresseComplete: contribuableData.adresse || "Adresse non spécifiée",
        pays: "RDC"
      });
    } catch (error) {
      console.error("Erreur chargement localité:", error);
      setLocaliteInfo({
        adresseComplete: contribuableData.adresse || "Adresse non spécifiée",
        pays: "RDC"
      });
    } finally {
      setLoadingLocalite(false);
    }
  };

  const paymentStatusConfig = {
    'en_attente': { 
      label: 'En attente', 
      color: 'warning', 
      icon: <HourglassSplit className="me-1" />,
      description: 'Échéance à venir sans paiement'
    },
    'impaye': { 
      label: 'Impayé', 
      color: 'danger', 
      icon: <XCircle className="me-1" />,
      description: 'Échéance en retard sans paiement'
    },
    'payee': { 
      label: 'Soldée', 
      color: 'success', 
      icon: <CheckCircle className="me-1" />,
      description: 'Échéance entièrement payée'
    },
    'partiel': { 
      label: 'Paiement partiel', 
      color: 'warning', 
      icon: <Percent className="me-1" />,
      description: 'Échéance partiellement payée'
    }
  };
  
  const paymentMethods = [
    { id: "cash", label: "Espèces", icon: <Cash className="me-2" />, color: "success", description: "Paiement en espèces" },
    { id: "mobile_money", label: "Mobile Money", icon: <PhoneVibrate className="me-2" />, color: "primary", description: "Orange Money, Wave, etc." },
    { id: "credit_card", label: "Carte Bancaire", icon: <CreditCard2Front className="me-2" />, color: "warning", description: "Visa, Mastercard" }
  ];
  
  const paymentTypes = [
    { id: "full", label: "Collecte complet", icon: <CheckCircle className="me-2" />, color: "success", description: "Collecter le montant total de l'échéance" },
    { id: "partial", label: "Collecte partiel", icon: <Percent className="me-2" />, color: "warning", description: "Collecter seulement une partie du montant" }
  ];

  const getAuthToken = () => sessionStorage.getItem("authToken");
  
  const getHeaders = useCallback(() => {
    const token = getAuthToken(); 
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }, []);
  
  const showToastMessage = (message, type = "success") => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const handleCollectPayment = (period) => {
    navigate(`/collecte/${taxId}/${contribuableId}/${period.echeance_id}`, {
      state: {
        period: period,
        tax: tax,
        contribuable: contribuable
      }
    });
  };

  const getDaysLate = (dueDate) => {
    const today = new Date();
    const due = new Date(dueDate);
    if (due >= today) return 0;
    const diffTime = Math.abs(today - due);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };
  
  const getMonthName = (date) => {
    const monthNames = [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];
    return monthNames[date.getMonth()];
  };
  
  const getFrequency = (freq) => {
    const frequencies = {
      'annuelle': 'Annuelle',
      'trimestrielle': 'Trimestrielle',
      'mensuelle': 'Mensuelle',
      'semestrielle': 'Semestrielle',
      'annuel': 'Annuelle',
      'trimestriel': 'Trimestrielle',
      'mensuel': 'Mensuelle',
      'semestriel': 'Semestrielle',
      'annual': 'Annuelle',
      'quarterly': 'Trimestrielle',
      'monthly': 'Mensuelle',
      'biannual': 'Semestrielle'
    };
    return frequencies[freq?.toLowerCase()] || freq || 'Non spécifiée';
  };
  
  const getPaymentPercentage = (period) => {
    const montantInitial = parseFloat(period.montant_initial || period.montant_du || 0);
    const montantPaye = parseFloat(period.montant_paye || 0);
    if (montantInitial === 0) return 100;
    return Math.round((montantPaye / montantInitial) * 100);
  };

  const getPaymentStatus = (period) => {
    if (!period) return 'en_attente';
    
    if (period.statut === 'completed') return 'payee';
    if (period.statut === 'partial') return 'partiel';
    
    const montantInitial = parseFloat(period.montant_initial || 0);
    const montantPaye = parseFloat(period.montant_paye || 0);
    
    if (montantPaye >= montantInitial && montantInitial > 0) return 'payee';
    if (montantPaye > 0 && montantPaye < montantInitial) return 'partiel';
    
    const dueDate = new Date(period.due_date);
    const today = new Date();
    
    if (dueDate < today) return 'impaye';
    return 'en_attente';
  };

  const getPaymentStatusBadge = (period) => {
    const status = getPaymentStatus(period);
    const config = paymentStatusConfig[status];
    const percentage = getPaymentPercentage(period);
    
    let label = config.label;
    if (status === 'partiel') {
      label = `${config.label} (${percentage}%)`;
    }
    
    return (
      <Badge bg={config.color} className="px-3 py-2 d-flex align-items-center gap-1">
        {config.icon}
        {label}
      </Badge>
    );
  };

  const getDateStatusBadge = (period) => {
    const today = new Date();
    const dueDate = new Date(period.due_date);
    const daysLate = getDaysLate(period.due_date);
    const status = getPaymentStatus(period);
    
    if (dueDate < today && status !== 'payee') {
      return (
        <Badge bg="danger" className="px-3 py-2">
          <ExclamationTriangle className="me-1" />
          En retard ({daysLate} jours)
        </Badge>
      );
    } else if (dueDate > today) {
      const daysRemaining = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
      return (
        <Badge bg="info" className="px-3 py-2">
          <CalendarEvent className="me-1" />
          À venir ({daysRemaining} jours)
        </Badge>
      );
    } else {
      return (
        <Badge bg="warning" className="px-3 py-2">
          <Clock className="me-1" />
          Aujourd'hui
        </Badge>
      );
    }
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'en_attente': return <HourglassSplit className="text-warning" />;
      case 'impaye': return <XCircle className="text-danger" />;
      case 'payee': return <CheckCircle className="text-success" />;
      case 'partiel': return <Percent className="text-warning" />;
      default: return <HourglassSplit className="text-secondary" />;
    }
  };

  const formatCurrency = (amount, currency = defaultCurrency) => {
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' ' + currency;
  };
  
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Date invalide";
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return dateString || "Non spécifiée";
    }
  };

  const formatDateLong = (dateString) => {
    if (!dateString) return "Non spécifié";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Date invalide";
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const fetchPaymentByReference = async (ref) => {
    try {
      console.log("=== RECHERCHE PAIEMENT PAR RÉFÉRENCE ===");
      console.log("Référence:", ref);
      
      const response = await axios.get(`${PAYMENT_ENDPOINT}/${ref}`, { headers: getHeaders() });
      
      console.log("Réponse API paiement complète:", JSON.stringify(response.data, null, 2));
      
      if (response.data && response.data.code === 200 && response.data.paiement) {
        const paiementData = response.data.paiement;
        
        console.log("Agent dans la réponse:", paiementData.agent);
        console.log("Agent via relation:", paiementData.agent_relation);
        
        let agentData = null;
        
        if (paiementData.agent && Object.keys(paiementData.agent).length > 0) {
          agentData = paiementData.agent;
        } else if (paiementData.agent_user && Object.keys(paiementData.agent_user).length > 0) {
          agentData = paiementData.agent_user;
        } else if (paiementData.agent_relation && Object.keys(paiementData.agent_relation).length > 0) {
          agentData = paiementData.agent_relation;
        }
        
        if (agentData) {
          console.log("✅ Agent collecteur trouvé:", agentData);
          setAgentInfo({
            id: agentData.user_id || agentData.id,
            nom: agentData.admin_lname || agentData.last_name || agentData.full_name?.split(' ')[1] || '',
            prenom: agentData.admin_fname || agentData.first_name || agentData.full_name?.split(' ')[0] || '',
            fonction: agentData.admin_fonction || agentData.fonction || agentData.role?.name || "Agent de collecte",
            matricule: agentData.matricule_interne || agentData.code_agent_interne || agentData.user_id?.toString() || '',
            email: agentData.email,
            telephone: agentData.admin_phone || agentData.telephone
          });
        } else {
          console.warn("⚠️ Aucune information d'agent trouvée dans la réponse");
          const user = JSON.parse(sessionStorage.getItem("user") || "{}");
          if (user && (user.user_id || user.id)) {
            setAgentInfo({
              id: user.user_id || user.id,
              nom: user.admin_lname || user.last_name || '',
              prenom: user.admin_fname || user.first_name || '',
              fonction: user.admin_fonction || user.fonction || "Agent de collecte",
              matricule: user.matricule_interne || user.code_agent_interne || '',
              email: user.email,
              telephone: user.admin_phone || user.telephone
            });
          }
        }
        
        return paiementData;
      }
      return null;
    } catch (error) {
      console.error("Erreur récupération paiement:", error);
      if (error.response?.status === 404) {
        setApiError("Paiement non trouvé");
      }
      return null;
    }
  };

  const generateBordereauPaiement = async (period) => {
    const receiptNumber = period?.echeance_id || period?.id || `RCP-${Date.now()}`;
    const montantInitial = parseFloat(period?.montant_initial || 0);
    const montantPaye = parseFloat(period?.montant_paye || 0);
    const montantRestant = period?.montant_restant || 0;
    const currentDate = new Date();
    const periodLabel = period?.period_label || "Période non spécifiée";
    
    const communeNom = localiteInfo?.commune || "";
    const villeNom = localiteInfo?.ville || "";
    const provinceNom = localiteInfo?.province || "";
    const paysNom = localiteInfo?.pays || "RDC";
    const adresseComplete = localiteInfo?.adresseComplete || contribuable?.adresse || "Non spécifiée";
    
    const agentNom = agentInfo 
      ? `${agentInfo.prenom || ''} ${agentInfo.nom || ''}`.trim() || "Agent"
      : "Agent non spécifié";
    const agentFonction = agentInfo?.fonction || "Agent de collecte";
    const agentMatricule = agentInfo?.matricule || "";
    const agentTelephone = agentInfo?.telephone || "";
    
    let qrCodeBase64 = '';
    let rid = '';
    
    try {
      console.log("📱 Génération du QR Code via API...");
      const qrResponse = await axios.post(
        `${API_BASE_URL}/qrcode`,
        { payment_id: receiptNumber },
        { headers: getHeaders() }
      );
      
      console.log("Réponse QR Code API:", qrResponse.data);
      
      if (qrResponse.data && qrResponse.data.rid) {
        rid = qrResponse.data.rid;
        qrCodeBase64 = await QRCode.toDataURL(rid, {
          width: 120,
          margin: 1,
          color: { dark: '#1a3c5e', light: '#ffffff' }
        });
        console.log("✅ QR Code généré avec succès avec le RID");
      } else {
        console.warn("⚠️ Aucun RID reçu de l'API, fallback sur les données");
        const fallbackData = JSON.stringify({
          reference: receiptNumber,
          montant: montantPaye,
          devise: defaultCurrency,
          date: period?.due_date || new Date().toISOString(),
          contribuable: contribuable?.nom_contribuable,
          taxe: tax?.name,
          periode: periodLabel,
          statut: getPaymentStatus(period) === 'payee' ? 'PAYÉ' : 'IMPAYÉ'
        });
        qrCodeBase64 = await QRCode.toDataURL(fallbackData, {
          width: 120,
          margin: 1,
          color: { dark: '#1a3c5e', light: '#ffffff' }
        });
      }
    } catch (error) {
      console.error("❌ Erreur génération QR Code via API:", error);
      const fallbackData = JSON.stringify({
        reference: receiptNumber,
        montant: montantPaye,
        devise: defaultCurrency,
        date: period?.due_date || new Date().toISOString()
      });
      try {
        qrCodeBase64 = await QRCode.toDataURL(fallbackData, {
          width: 120,
          margin: 1,
          color: { dark: '#1a3c5e', light: '#ffffff' }
        });
      } catch (qrError) {
        console.error("Erreur génération QR Code fallback:", qrError);
      }
    }
    
    const getPaymentMethodLabel = () => {
      return 'Paiement en ligne';
    };

    const htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
          <meta charset="UTF-8">
          <title>Bordereau de paiement - ${receiptNumber}</title>
          <style>
              * { margin: 0; padding: 0; box-sizing: border-box; }
              body { font-family: 'Arial', sans-serif; margin: 0; padding: 0; background: white; }
              @media print {
                  @page { size: A5; margin: 0.5cm; }
                  body { width: 148mm; height: 210mm; padding: 0; margin: 0; }
                  .receipt { width: 148mm; min-height: 210mm; margin: 0; padding: 5mm; box-sizing: border-box; }
              }
              .receipt { max-width: 148mm; margin: 0 auto; background: white; padding: 5mm; box-sizing: border-box; }
              .header { border-bottom: 2px solid #1a3c5e; padding-bottom: 10px; margin-bottom: 15px; }
              .header-top { display: flex; justify-content: center; align-items: center; margin-bottom: 10px; }
              .logo-section { display: flex; align-items: center; gap: 12px; }
              .logo { height: 60px; }
              .maison-info { text-align: left; }
              .maison-nom { font-size: 14px; font-weight: bold; color: #1a3c5e; }
              .maison-ville { font-size: 10px; color: #6c757d; }
              .receipt-meta { display: flex; justify-content: space-between; margin-top: 10px; padding-top: 8px; border-top: 0.5px dashed #dee2e6; }
              .meta-item { text-align: center; }
              .meta-label { font-size: 8px; text-transform: uppercase; color: #6c757d; }
              .meta-value { font-size: 10px; font-weight: bold; color: #1a3c5e; margin-top: 2px; }
              .title { text-align: center; margin: 15px 0; }
              .title h2 { font-size: 14px; color: #28a745; text-transform: uppercase; letter-spacing: 1px; }
              .content { margin: 15px 0; }
              .sections { display: flex; gap: 20px; margin-bottom: 20px; }
              .section { flex: 1; }
              .section-title { font-size: 10px; font-weight: bold; color: #1a3c5e; text-transform: uppercase; border-bottom: 1px solid #e0e0e0; padding-bottom: 5px; margin-bottom: 10px; }
              .info-line { margin-bottom: 8px; font-size: 9px; line-height: 1.3; }
              .info-label { color: #6c757d; min-width: 70px; display: inline-block; font-size: 8px; }
              .info-value { color: #2c3e50; font-weight: 500; font-size: 9px; }
              .amount-table { background: #f8f9fa; padding: 10px; margin: 15px 0; border-radius: 6px; }
              .amount-row { display: flex; justify-content: space-between; padding: 5px 0; font-size: 10px; }
              .amount-row.border-bottom { border-bottom: 0.5px solid #dee2e6; }
              .amount-row.total { margin-top: 5px; padding-top: 8px; border-top: 1.5px solid #1a3c5e; font-size: 11px; font-weight: bold; }
              .amount-row.total .amount-value { font-size: 12px; color: #28a745; }
              .status-box { text-align: center; margin: 15px 0; padding: 8px; background: ${montantRestant === 0 ? '#d4edda' : '#fff3cd'}; color: ${montantRestant === 0 ? '#155724' : '#856404'}; border-radius: 6px; font-size: 9px; font-weight: bold; }
              .agent-info { margin-top: 15px; padding: 12px; background: #fbfcfcff; border-radius: 8px; border-left: 1px solid #1a3c5e; }
              .agent-info .agent-label { color: #1a3c5e; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 10px; font-size: 9px; }
              .agent-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px 16px; }
              .agent-grid .info-line { margin-bottom: 0; display: flex; align-items: baseline; flex-wrap: wrap; }
              .agent-grid .info-label { color: #6c757d; min-width: 65px; display: inline-block; font-size: 8px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px; }
              .agent-grid .info-value { color: #2c3e50; font-weight: 500; font-size: 9px; word-break: break-word; }
              .signature-footer { margin-top: 20px; display: flex; justify-content: flex-end; }
              .signature-box { width: 200px; text-align: center; }
              .signature-line { border-top: 1px solid #2c3e50; margin-top: 30px; padding-top: 6px; }
              .signature-fonction { font-size: 8px; color: #6c757d; margin-top: 4px; }
              .signature-nom { font-size: 9px; font-weight: bold; color: #1a3c5e; margin-top: 2px; }
              .footer { margin-top: 15px; padding-top: 10px; border-top: 0.5px solid #e0e0e0; font-size: 7px; color: #adb5bd; display: flex; justify-content: space-between; align-items: center; }
              .footer-left { text-align: left; }
              .footer-right { text-align: right; font-size: 6px; color: #adb5bd; }
              .commune-coords { margin-top: 8px; font-size: 7px; color: #6c757d; text-align: center; border-top: 0.5px solid #e9ecef; padding-top: 8px; }
              .qrcode-section { display: flex; justify-content: center; align-items: center; margin: 15px 0; padding: 10px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef; }
              .qrcode-container { text-align: center; }
              .qrcode-image { width: 100px; height: 100px; margin-bottom: 5px; }
              .qrcode-label { font-size: 7px; color: #6c757d; text-transform: uppercase; letter-spacing: 0.5px; }
          </style>
      </head>
      <body>
          <div class="receipt">
              <div class="header">
                  <div class="header-top">
                      <div class="logo-section">
                          <img src="${mairieLogo}" alt="Logo Maison Communale" class="logo" />
                          <div class="maison-info">
                              <div class="maison-nom">MAISON COMMUNALE${communeNom ? ` DE ${communeNom.toUpperCase()}` : ''}</div>
                              <div class="maison-ville">${villeNom} ${provinceNom} - ${paysNom}</div>
                          </div>
                      </div>
                  </div>
                  <div class="receipt-meta">
                      <div class="meta-item"><div class="meta-label">QUITTANCE N°</div><div class="meta-value">${receiptNumber}</div></div>
                      <div class="meta-item"><div class="meta-label">DATE D'ÉMISSION</div><div class="meta-value">${formatDateLong(currentDate)}</div></div>
                  </div>
              </div>
              <div class="title"><h2>QUITTANCE DE PAIEMENT</h2></div>
              <div class="content">
                  <div class="sections">
                      <div class="section">
                          <div class="section-title">CONTRIBUABLE</div>
                          <div class="info-line"><span class="info-label">Nom complet</span><span class="info-value">${contribuable?.nom_contribuable || 'Non spécifié'}</span></div>
                          <div class="info-line"><span class="info-label">Identifiant</span><span class="info-value">${contribuable?.contribuable_id || 'N/A'}</span></div>
                          <div class="info-line"><span class="info-label">Téléphone</span><span class="info-value">${contribuable?.telephone || 'Non spécifié'}</span></div>
                          <div class="info-line"><span class="info-label">Adresse</span><span class="info-value">${adresseComplete}</span></div>
                      </div>
                      <div class="section">
                          <div class="section-title">TAXE</div>
                          <div class="info-line"><span class="info-label">Désignation</span><span class="info-value">${tax?.name || 'Taxe'}</span></div>
                          <div class="info-line"><span class="info-label">Période</span><span class="info-value">${period?.period_label || 'Période non spécifiée'}</span></div>
                          <div class="info-line"><span class="info-label">Mode de paiement</span><span class="info-value">${getPaymentMethodLabel()}</span></div>
                      </div>
                  </div>
                  
                  <div class="amount-table">
                      <div class="amount-row border-bottom"><span class="amount-label">Montant initial</span><span class="amount-value">${formatCurrency(montantInitial)}</span></div>
                      <div class="amount-row border-bottom"><span class="amount-label">Montant payé</span><span class="amount-value" style="color: #28a745;">${formatCurrency(montantPaye)}</span></div>
                      <div class="amount-row total"><span class="amount-label">RESTE À PAYER</span><span class="amount-value">${formatCurrency(montantRestant)}</span></div>
                  </div>
                  
                  <div class="status-box">${montantPaye >= montantInitial ? 'STATUT : PAYÉ INTÉGRALEMENT' : 'STATUT : PAIEMENT PARTIEL'}</div>
                  
                  <div class="agent-info">
                      <div class="agent-label"> AGENT COLLECTEUR</div>
                      <div class="agent-grid">
                          <div class="info-line">
                              <span class="info-label">Nom</span>
                              <span class="info-value">${agentNom}</span>
                          </div>
                          <div class="info-line">
                              <span class="info-label">Téléphone</span>
                              <span class="info-value">${agentTelephone || 'Non spécifié'}</span>
                          </div>
                          ${agentMatricule ? `
                          <div class="info-line">
                              <span class="info-label">Matricule</span>
                              <span class="info-value">${agentMatricule}</span>
                          </div>
                          ` : ''}
                          <div class="info-line">
                              <span class="info-label">Fonction</span>
                              <span class="info-value">${agentFonction}</span>
                          </div>
                          <div class="info-line">
                              <span class="info-label">Date collecte</span>
                              <span class="info-value">${formatDateLong(currentDate)}</span>
                          </div>
                          <div class="info-line">
                              <span class="info-label">Heure</span>
                              <span class="info-value">${currentDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</span>
                          </div>
                      </div>
                  </div>
                  
                  ${qrCodeBase64 ? `
                  <div class="qrcode-section">
                      <div class="qrcode-container">
                          <img src="${qrCodeBase64}" alt="QR Code" class="qrcode-image" />
                          <div class="qrcode-label">Scannez pour vérifier le paiement</div>
                          ${rid ? `<div class="qrcode-rid" style="font-size: 6px; color: #999; margin-top: 4px;">ID: ${rid.substring(0, 8)}...</div>` : ''}
                      </div>
                  </div>
                  ` : ''}
              </div>
              <div class="commune-coords">Maison Communale${communeNom ? ` de ${communeNom}` : ''} | ${villeNom} ${provinceNom} - ${paysNom}</div>
              <div class="signature-footer"><div class="signature-box"><div class="signature-line"></div><div class="signature-fonction">Le Bourgmestre</div><div class="signature-nom">POBA MAYIMONA Jean Serges</div></div></div>
              <div class="footer"><div class="footer-left">Document généré le ${new Date().toLocaleString('fr-FR')}</div><div class="footer-right">Généré par SyncTaxe</div></div>
          </div>
      </body>
      </html>
    `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);
    
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();
    
    iframe.contentWindow.onload = () => {
        iframe.contentWindow.print();
        setTimeout(() => {
            if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
            }
        }, 1000);
    };
  };

  const fetchCurrenciesByCountry = async () => {
    try {
      setLoadingCurrencies(true);
      const countryCode = sessionStorage.getItem("country_code") || "GA";
      
      const response = await axios.get(`${API_BASE_URL}/currencies/${countryCode}`, {
        headers: getHeaders(),
      });
      
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const currencies = response.data.map(curr => ({
          code: curr.currency,
          name: getCurrencyName(curr.currency),
          symbol: getCurrencySymbol(curr.currency),
          is_default: curr.default === 1,
          exchange_rate: 1
        }));
        
        setAvailableCurrencies(currencies);
        
        const rates = {};
        currencies.forEach(curr => {
          rates[curr.code] = 1;
        });
        setConversionRates(rates);
        
        const defaultCurr = currencies.find(c => c.is_default) || currencies[0];
        if (defaultCurr) {
          setSelectedCurrency(defaultCurr.code);
        }
      } else {
        setAvailableCurrencies([
          {
            code: defaultCurrency,
            name: getCurrencyName(defaultCurrency),
            symbol: getCurrencySymbol(defaultCurrency),
            is_default: true,
            exchange_rate: 1
          }
        ]);
        setConversionRates({ [defaultCurrency]: 1 });
      }
    } catch (error) {
      console.error("Erreur chargement devises:", error);
      setAvailableCurrencies([
        {
          code: defaultCurrency,
          name: getCurrencyName(defaultCurrency),
          symbol: getCurrencySymbol(defaultCurrency),
          is_default: true,
          exchange_rate: 1
        }
      ]);
      setConversionRates({ [defaultCurrency]: 1 });
    } finally {
      setLoadingCurrencies(false);
    }
  };

  const getCurrencyName = (currencyCode) => {
    const names = {
      'XAF': 'Franc CFA (CEMAC)',
      'XOF': 'Franc CFA (UEMOA)',
      'USD': 'Dollar US',
      'EUR': 'Euro',
      'GBP': 'Livre Sterling',
      'CAD': 'Dollar Canadien',
      'CHF': 'Franc Suisse'
    };
    return names[currencyCode] || currencyCode;
  };

  const getCurrencySymbol = (currencyCode) => {
    const symbols = {
      'XAF': 'FCFA',
      'XOF': 'FCFA',
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'CAD': 'C$',
      'CHF': 'CHF'
    };
    return symbols[currencyCode] || currencyCode;
  };

  const convertCurrency = async (fromCurrency, toCurrency, amount) => {
    if (fromCurrency === toCurrency) return amount;
    
    try {
      const response = await axios.post(
        `${API_BASE_URL}/convert`,
        { from: fromCurrency, to: toCurrency, amount: amount },
        { headers: getHeaders() }
      );
      
      if (response.data && response.data.result) {
        setConversionRates(prev => ({
          ...prev,
          [toCurrency]: parseFloat(response.data.rate)
        }));
        return response.data.result;
      }
      return amount;
    } catch (error) {
      console.error("Erreur conversion:", error);
      return amount;
    }
  };

  const convertAmountSync = (amount, fromCurrency, toCurrency) => {
    if (fromCurrency === toCurrency) return amount;
    if (!amount || isNaN(amount)) return 0;
    const rate = conversionRates[toCurrency] || 1;
    return Math.round((amount * rate) * 100) / 100;
  };

  useEffect(() => {
    const updateExchangeRate = async () => {
      if (selectedCurrency !== defaultCurrency && amount > 0) {
        await convertCurrency(defaultCurrency, selectedCurrency, amount);
      }
    };
    updateExchangeRate();
  }, [selectedCurrency, amount]);

  const detecterReseauMobile = async (phoneNumber) => {
    setRechercheLoading(true);
    setDetectionError("");
    const countryCode = sessionStorage.getItem("country_code") || "GA";
    try {
      const response = await axios.get(
        `${API_BASE_URL}/payments/network?msisdn=${phoneNumber}&country=${countryCode}&type=mobile_money&source=bo`,
        { headers: getHeaders() }
      );

      const data = response.data;

      if (response.status === 200 && data.statusRequest === 200) {
        setNetworkName(data.mobile_money_svce || data.network);
        setNetworkLogo(data.mobile_money_logo);
        setNetworkCode(data.mobile_money_code);
        setCountryCode(data.country);

        const wallets = [];
        const hasWallet = (data.has_wallet_1 || '').toString().toLowerCase() === 'yes';
        
        if (hasWallet) {
          wallets.push({
            code: data.mobile_money_code,
            name: data.mobile_money_svce || data.network,
            logo: data.mobile_money_logo,
            type: 'principal'
          });
          wallets.push({
            code: data.wallet_code,
            name: data.wallet_name_1,
            logo: data.wallet_logo_1,
            type: 'supplementaire'
          });
        } else {
          wallets.push({
            code: data.mobile_money_code,
            name: data.mobile_money_svce || data.network,
            logo: data.mobile_money_logo,
            type: 'principal'
          });
        }
        
        setWalletsSupplementaires(wallets);
        setSelectedWallet(wallets[0]?.code || "");
        setDetectionError(null);
      } else {
        setDetectionError(data.message || 'Réseau non trouvé.');
      }
    } catch (error) {
      setDetectionError(error.response?.data?.message || 'Erreur de connexion.');
    } finally {
      setRechercheLoading(false);
    }
  };

  useEffect(() => {
    const numeroNettoye = numeroPaiement.replace(/\s/g, '');
    if (numeroNettoye.length >= 7) {
      detecterReseauMobile(numeroPaiement);
    } else {
      setNetworkName("");
      setNetworkLogo("");
      setNetworkCode("");
      setCountryCode("");
      setWalletsSupplementaires([]);
      setSelectedWallet("");
      setDetectionError("");
    }
  }, [numeroPaiement]);

  useEffect(() => {
    fetchActivitiesMapping();
    fetchCurrenciesByCountry();
    fetchActivitesAndSousComptes();
  }, []);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  
  const getFilteredAndPaginatedPeriods = (periodsList) => {
    let filtered = [...periodsList];
    
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(period =>
        period.period_label?.toLowerCase().includes(searchLower) ||
        period.year?.toString().includes(searchLower)
      );
    }
    
    if (sortConfig.key) {
      filtered.sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];
        
        if (sortConfig.key === 'due_date') {
          return new Date(aValue) - new Date(bValue);
        }
        
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
        }
        
        const compareResult = String(aValue).localeCompare(String(bValue));
        return sortConfig.direction === 'ascending' ? compareResult : -compareResult;
      });
    }
    
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginated = filtered.slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    
    return { filtered, paginated, totalPages, totalItems: filtered.length };
  };

  const handleViewDetails = (period) => {
    setSelectedDetailPeriod(period);
    setShowDetailsPeriodModal(true);
  };

  const calculateStatsAndSortPeriods = (periodsData) => {
    if (!periodsData || periodsData.length === 0) {
      setOverduePeriods([]);
      setUpcomingPeriods([]);
      setPaidPeriods([]);
      setStats({
        overdueTotal: 0,
        upcomingTotal: 0,
        paidTotal: 0,
        totalAmount: 0,
        totalInitialAmount: 0,
        overdueCount: 0,
        upcomingCount: 0,
        paidCount: 0,
        partialCount: 0,
        completedCount: 0,
        totalCount: 0
      });
      return;
    }

    const overdue = [];
    const upcoming = [];
    const paid = [];
    let partialCount = 0;
    let completedCount = 0;
    let totalPaidAmount = 0;

    periodsData.forEach(p => {
      const dueDate = new Date(p.due_date);
      const today = new Date();
      const status = getPaymentStatus(p);
      const montantPaye = parseFloat(p.montant_paye || 0);
      
      totalPaidAmount += montantPaye;
      
      if (status === 'partiel') {
        partialCount++;
      }
      if (status === 'payee') {
        completedCount++;
      }
      
      if (status === 'payee') {
        paid.push(p);
      } 
      else if (dueDate < today) {
        overdue.push(p);
      } 
      else {
        upcoming.push(p);
      }
    });

    const overdueTotal = overdue.reduce((sum, p) => sum + (p.montant_restant || 0), 0);
    const upcomingTotal = upcoming.reduce((sum, p) => sum + (p.montant_restant || 0), 0);
    const paidTotal = totalPaidAmount;
    const totalInitialAmount = periodsData.reduce((sum, p) => sum + (p.montant_initial || 0), 0);

    setOverduePeriods(overdue);
    setUpcomingPeriods(upcoming);
    setPaidPeriods(paid);
    
    setStats({
      overdueTotal,
      upcomingTotal,
      paidTotal,
      totalAmount: overdueTotal + upcomingTotal,
      totalInitialAmount,
      overdueCount: overdue.length,
      upcomingCount: upcoming.length,
      paidCount: paid.length,
      partialCount,
      completedCount,
      totalCount: periodsData.length
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        let url = `${API_BASE_URL}/terms?usager_id=${contribuableId}&taxe_id=${taxId}`;
        
        if (activityId && activityId !== "undefined" && activityId !== "null") {
          url += `&activite_id=${activityId}`;
        }
        console.log("🔍 URL appelée:", url);
        const response = await axios.get(url, { headers: getHeaders() });
        
        if (response.data.code === 200 && response.data.echeances) {
          const echeances = response.data.echeances;
          
          const transformedPeriods = echeances.map(echeance => {
            const dueDate = new Date(echeance.date_echeance);
            const montantInitial = parseFloat(echeance.montant_initial || 0);
            const montantPaye = parseFloat(echeance.montant_paye || 0);
            const montantRestant = Math.max(0, montantInitial - montantPaye);
            const paymentPercentage = montantInitial > 0 ? (montantPaye / montantInitial) * 100 : 0;
            
            return {
              id: echeance.id,
              echeance_id: echeance.echeance_id || echeance.id,
              taxe_id: echeance.taxe_id,
              usager_id: echeance.usager_id,
              period_label: `${getMonthName(dueDate)} ${dueDate.getFullYear()}`,
              montant_initial: montantInitial,
              montant_paye: montantPaye,
              montant_restant: montantRestant,
              payment_percentage: paymentPercentage,
              statut: echeance.statut || 'en_attente',
              due_date: echeance.date_echeance,
              year: dueDate.getFullYear(),
              month: dueDate.getMonth() + 1,
              days_late: getDaysLate(echeance.date_echeance),
              activite_contribuable: echeance.activite_contribuable || null,
              activite_nom: activitiesMap[echeance.activite_contribuable] || 'Activité principale',
              taxe: echeance.taxe,
              contribuable: echeance.contribuable
            };
          });
          
          calculateStatsAndSortPeriods(transformedPeriods);
          
          setPeriods(transformedPeriods);
          
          if (transformedPeriods.length > 0) {
            const firstPeriod = transformedPeriods[0];
            
            setTax({
              id: taxId,
              taxe_id: firstPeriod.taxe_id || taxId,
              name: firstPeriod.taxe?.titre || "Taxe Non Spécifiée",
              code: `TX-${taxId}`,
              frequency: firstPeriod.taxe?.frequence || "quarterly",
              status: "active",
              montant_base: firstPeriod.montant_initial || 0,
              description: firstPeriod.taxe?.description || "Description non disponible"
            });
            
            setContribuable({
              id: contribuableId,
              contribuable_id: firstPeriod.contribuable?.contribuable_id || contribuableId,
              nom_contribuable: firstPeriod.contribuable?.nom_contribuable || "Contribuable Inconnu",
              email: firstPeriod.contribuable?.email || "",
              telephone: firstPeriod.contribuable?.telephone || "",
              adresse: firstPeriod.contribuable?.adresse || "",
              localite_id: firstPeriod.contribuable?.localite_id || null,
              type: "Entreprise",
              activite_contribuable: firstPeriod.activite_contribuable || null
            });
          }
          
          setUsingMockData(false);
        } else {
          setPeriods([]);
          calculateStatsAndSortPeriods([]);
        }
      } catch (err) {
        console.error('Erreur de chargement:', err);
        setPeriods([]);
        calculateStatsAndSortPeriods([]);
        showToastMessage("Erreur lors du chargement des données", "error");
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [taxId, contribuableId, activityId]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ La fonction getCurrentPeriods est maintenant correctement définie avant utilisation
  const currentPeriods = getCurrentPeriods();
  const { paginated: paginatedPeriods, totalPages, totalItems } = getFilteredAndPaginatedPeriods(currentPeriods);

  const getActiveFilterLabel = () => {
    if (!activityId || activityId === "undefined" || activityId === "null") return null;
    if (activityId === "main") return "Activité principale";
    return activitiesMap[parseInt(activityId)] || `Activité ${activityId}`;
  };

  if (loading) {
    return (
      <>
        <Header />
             <div className="main main-app p-3 p-lg-4">
               <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                 <div className="text-center">
                   <div className="spinner-grow text-primary" style={{ width: '4rem', height: '4rem' }} />
                   <h4 className="mt-4 text-primary">Chargement...</h4>
                   <p className="text-muted">Récupération des informations de la taxe.</p>
                   {loadingDetails && (
                     <div className="mt-3">
                       <div className="progress" style={{ height: '4px', width: '200px', margin: '0 auto' }}>
                         <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: '100%' }}></div>
                       </div>
                       <p className="small text-muted mt-2">Chargement des taxes et échéances...</p>
                     </div>
                   )}
                 </div>
               </div>
             </div>
             <Footer />
      </>
    );
  }
  
  return (
    <>
      <Header />
      
      <div className="main main-app p-3 p-lg-4">
        <Container fluid>
          {/* Toast Notifications */}
          <ToastContainer position="top-end" className="p-3" style={{ 
            zIndex: 9999,
            position: 'fixed',
            top: '20px',
            right: '20px'
          }}>
            <Toast 
              show={showToast} 
              onClose={() => setShowToast(false)} 
              delay={5000} 
              autohide
              className={`border-0 shadow-lg ${
                toastType === "success" ? "bg-success text-white" :
                toastType === "error" ? "bg-danger text-white" :
                toastType === "warning" ? "bg-warning text-dark" :
                "bg-info text-white"
              }`}
            >
              <Toast.Header className={`border-0 ${
                toastType === "success" ? "bg-success text-white" :
                toastType === "error" ? "bg-danger text-white" :
                toastType === "warning" ? "bg-warning text-dark" :
                "bg-info text-white"
              }`}>
                <strong className="me-auto">
                  {toastType === "success" ? " Succès" :
                   toastType === "error" ? " Erreur" :
                   toastType === "warning" ? " Attention" :
                   "Information"}
                </strong>
                <Button 
                  variant="close" 
                  onClick={() => setShowToast(false)}
                  className={`${
                    toastType === "success" || toastType === "error" || toastType === "info" 
                      ? "btn-close-white" 
                      : ""
                  }`}
                />
              </Toast.Header>
              <Toast.Body>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">{toastMessage}</div>
                </div>
              </Toast.Body>
            </Toast>
          </ToastContainer>
          
          {/* En-tête avec navigation */}
          <Row className="mb-4">
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="d-flex align-items-center mb-3">
                    <Button 
                      variant="light" 
                      onClick={() => navigate(-1)}
                      className="me-3 rounded-circle"
                      style={{ width: '40px', height: '40px' }}
                    >
                      <ArrowLeft />
                    </Button>
                    <div>
                      <h1 className="h3 mb-1 text-gradient-primary">
                        <CashCoin className="me-2" />
                        Échéances de taxe
                      </h1>
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb breadcrumb-arrow mb-0">
                          <li className="breadcrumb-item">
                            <Button variant="link" className="p-0 text-decoration-none" onClick={() => navigate(-1)}>
                              Détails contribuable
                            </Button>
                          </li>
                          <li className="breadcrumb-item active" aria-current="page">Échéances</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
                
                {usingMockData && (
                  <Badge bg="warning" className="px-3 py-2">
                    <InfoCircle className="me-2" />
                    Mode démonstration
                  </Badge>
                )}
              </div>
            </Col>
          </Row>
          
          {/* Cartes statistiques */}
          <Row className="mb-4 g-4">
            <Col lg={3} md={6}>
              <Card className="border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #dc3545 0%, #a71d2a 100%)', color: 'white' }}>
                <Card.Body className="position-relative">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h6 className="text-uppercase mb-1 opacity-75">Impayés</h6>
                      <h4 className="mb-0">{formatCurrency(stats.overdueTotal)}</h4>
                      <div className="mt-2">
                        <Badge bg="white" text="dark">
                          <XCircle className="me-1 text-danger" />
                          {stats.overdueCount} échéance(s)
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-statistic"><XCircle size={40} /></div>
                  </div>
                  <div className="statistic-wave"></div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={3} md={6}>
              <Card className="border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #ffc107 0%, #d39e00 100%)', color: 'white' }}>
                <Card.Body className="position-relative">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h6 className="text-uppercase mb-1 opacity-75">En attente</h6>
                      <h4 className="mb-0">{formatCurrency(stats.upcomingTotal)}</h4>
                      <div className="mt-2">
                        <Badge bg="white" text="dark">
                          <HourglassSplit className="me-1 text-warning" />
                          {stats.upcomingCount} échéance(s)
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-statistic"><HourglassSplit size={40} /></div>
                  </div>
                  <div className="statistic-wave"></div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={3} md={6}>
              <Card className="border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #198754 0%, #0d5c3a 100%)', color: 'white' }}>
                <Card.Body className="position-relative">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h6 className="text-uppercase mb-1 opacity-75">Soldées</h6>
                      <h4 className="mb-0">{formatCurrency(stats.paidTotal)}</h4>
                      <div className="mt-2">
                        <Badge bg="white" text="dark">
                          <CheckCircle className="me-1 text-success" />
                          {stats.paidCount} échéance(s)
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-statistic"><CheckCircle size={40} /></div>
                  </div>
                  <div className="statistic-wave"></div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={3} md={6}>
              <Card className="border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)', color: 'white' }}>
                <Card.Body className="position-relative">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h6 className="text-uppercase mb-1 opacity-75">Total initial</h6>
                      <h4 className="mb-0">{formatCurrency(stats.totalInitialAmount)}</h4>
                      <div className="mt-2">
                        <Badge bg="white" text="dark">
                          <Calculator className="me-1" />
                          {stats.totalCount} échéance(s)
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-statistic"><Calculator size={40} /></div>
                  </div>
                  <div className="statistic-wave"></div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          
          {/* Récapitulatif taxe et contribuable */}
          <Card className="border-0 shadow-lg mb-4">
            <div className="card-header-gradient bg-primary"></div>
            <Card.Body className="pt-4">
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="d-flex align-items-start mb-4">
                    <div className="avatar-xl bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center p-3 me-4">
                      <Receipt size={40} className="text-primary" />
                    </div>
                    <div className="flex-grow-1">
                      <h3 className="mb-1">{tax?.name || 'Taxe Non Spécifiée'}</h3>
                      <div className="d-flex flex-wrap gap-2 mb-2">
                        <Badge bg="info" className="px-3 py-2 d-flex align-items-center">
                          <span className="fw-medium">Code:</span> 
                          <span className="ms-2">{tax?.code || 'N/A'}</span>
                        </Badge>
                        <Badge bg="secondary" className="px-3 py-2 d-flex align-items-center">
                          <CalendarDate className="me-2" size={14} />
                          {getFrequency(tax?.frequency)}
                        </Badge>
                        {getActiveFilterLabel() && (
                          <Badge bg="success" className="ms-3 px-3 py-2">
                            <InfoCircle className="me-1" size={14} />
                            {getActiveFilterLabel()}
                          </Badge>
                        )}
                      </div>
                      <p className="text-muted mb-0">{tax?.description || 'Description non disponible'}</p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex align-items-start mb-4">
                    <div className="avatar-xl bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center p-3 me-4">
                      <Person size={40} className="text-info" />
                    </div>
                    <div className="flex-grow-1">
                      <h3 className="mb-1">{contribuable?.nom_contribuable?.toLocaleUpperCase('fr-FR') || 'Contribuable Inconnu'}</h3>
                      <div className="d-flex flex-wrap gap-2 mb-2">
                        <Badge bg="dark" className="px-3 py-2 d-flex align-items-center">
                          <span className="fw-medium">ID:</span> 
                          <span className="ms-2">{contribuable?.contribuable_id || contribuable?.id || 'N/A'}</span>
                        </Badge>
                        <Badge bg="primary" className="px-3 py-2">{contribuable?.type || 'Particulier'}</Badge>
                      </div>
                      <div className="d-flex flex-column gap-2">
                        {contribuable?.email && (
                          <div className="d-flex align-items-center bg-light rounded-pill px-3 py-2">
                            <Envelope className="text-primary me-2" size={16} />
                            <small>{contribuable.email}</small>
                          </div>
                        )}
                        {contribuable?.telephone && (
                          <div className="d-flex align-items-center bg-light rounded-pill px-3 py-2">
                            <Phone className="text-primary me-2" size={16} />
                            <small>{contribuable.telephone}</small>
                          </div>
                        )}
                        {localiteInfo?.adresseComplete && (
                          <div className="d-flex align-items-center bg-light rounded-pill px-3 py-2">
                            <GeoAlt className="text-primary me-2" size={16} />
                            <small>{localiteInfo.adresseComplete}</small>
                          </div>
                        )}
                        {!localiteInfo?.adresseComplete && contribuable?.adresse && (
                          <div className="d-flex align-items-center bg-light rounded-pill px-3 py-2">
                            <GeoAlt className="text-primary me-2" size={16} />
                            <small>{contribuable.adresse}</small>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              {stats.totalCount > 0 && (
                <Row className="mt-3">
                  <Col md={12}>
                    <div className="d-flex justify-content-between align-items-center p-3 rounded" style={{background:'#ededed'}}>
                      <div>
                        <h6 className="mb-0">Résumé des échéances</h6>
                        <small className="text-muted">
                          Total initial: <strong>{formatCurrency(stats.totalInitialAmount)}</strong> • 
                          Payé: <strong className="text-success">{formatCurrency(stats.paidTotal)}</strong> • 
                          Restant: <strong className="text-danger">{formatCurrency(stats.totalInitialAmount - stats.paidTotal)}</strong>
                        </small>
                      </div>
                      <div className="text-end">
                        <div className="fw-medium">{stats.totalCount} échéance(s) total</div>
                        <div className="d-flex flex-wrap gap-2 justify-content-end mt-1">
                          {stats.completedCount > 0 && <Badge bg="success">✓ {stats.completedCount} soldée(s)</Badge>}
                          {stats.partialCount > 0 && <Badge bg="warning">⚠️ {stats.partialCount} partielle(s)</Badge>}
                          {stats.overdueCount > 0 && <Badge bg="danger">❌ {stats.overdueCount} impayée(s)</Badge>}
                          {stats.upcomingCount > 0 && <Badge bg="secondary">⏳ {stats.upcomingCount} en attente</Badge>}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </Card.Body>
          </Card>
          
          {/* Tableau des échéances avec onglets */}
          <Card className="border-0 shadow-lg">
            <Card.Body className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <div>
                  <h5 className="mb-0">
                    <CalendarDate className="me-2" />
                    Gestion des échéances
                  </h5>
                  <small className="text-muted">
                    {periods.length > 0 ? `${periods.length} échéance(s) trouvée(s)` : 'Aucune échéance trouvée'}
                  </small>
                </div>
                
                {periods.length > 0 && (
                  <div className="d-flex gap-2">
                    <InputGroup style={{ width: '250px' }}>
                      <InputGroup.Text><Search /></InputGroup.Text>
                      <Form.Control
                        placeholder="Rechercher une période..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      {searchTerm && (
                        <Button variant="outline-secondary" onClick={() => setSearchTerm("")}>
                          <XCircle size={14} />
                        </Button>
                      )}
                    </InputGroup>
                    
                    <Form.Select 
                      value={itemsPerPage} 
                      onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                      style={{ width: '100px' }}
                    >
                      <option value="5">5 / page</option>
                      <option value="10">10 / page</option>
                      <option value="25">25 / page</option>
                      <option value="50">50 / page</option>
                    </Form.Select>
                  </div>
                )}
              </div>
              
              {periods.length === 0 ? (
                <div className="text-center py-5">
                  <div className="mb-4"><CalendarX size={64} className="text-muted opacity-50" /></div>
                  <h5 className="text-muted mb-3">Aucune échéance trouvée</h5>
                  <p className="text-muted mb-4">Ce contribuable n'a pas d'échéance de paiement pour cette taxe.</p>
                  <div className="d-flex justify-content-center gap-3">
                    <Button variant="outline-primary" onClick={() => navigate(-1)}><ArrowLeft className="me-2" />Retour</Button>
                  </div>
                </div>
              ) : (
                <>
                  <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-4">
                    <Tab 
                      eventKey="overdue" 
                      title={
                        <div className="d-flex align-items-center px-3 py-2">
                          <XCircle className="me-2 text-danger" />
                          <span>Impayés</span>
                          {stats.overdueCount > 0 && <Badge bg="danger" className="ms-2">{stats.overdueCount}</Badge>}
                        </div>
                      }
                    >
                      <div className="pt-3">
                        {overduePeriods.length === 0 ? (
                          <div className="text-center py-5"><CheckCircle size={48} className="text-success mb-3 opacity-50" /><p className="text-muted">Aucun impayé trouvé</p></div>
                        ) : (
                          <>
                            <div className="table-responsive">
                              <Table hover className="table-custom">
                                <thead className="table-light">
                                  <tr>
                                    <th onClick={() => requestSort('period_label')} style={{ cursor: 'pointer' }}>Période</th>
                                    <th onClick={() => requestSort('due_date')} style={{ cursor: 'pointer' }}>Échéance</th>
                                    <th>Statut Paiement</th>
                                    <th>Statut Date</th>
                                    <th onClick={() => requestSort('montant_initial')} style={{ cursor: 'pointer' }}>Montant initial</th>
                                    <th>Intérêts</th>
                                    <th onClick={() => requestSort('montant_restant')} style={{ cursor: 'pointer' }}>Restant à payer</th>
                                    <th className="text-end">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {paginatedPeriods.map((period) => (
                                    <tr key={period.id} className="align-middle">
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <div className="bg-danger bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                                            {getStatusIcon(getPaymentStatus(period))}
                                          </div>
                                          <div>
                                            <div className="fw-medium">{period.period_label}</div>
                                            <small className="text-muted">Année {period.year}</small>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fw-medium">{formatDate(period.due_date)}</div>
                                        {period.days_late > 0 && <small className="text-danger">En retard de {period.days_late} jours</small>}
                                      </td>
                                      <td>{getPaymentStatusBadge(period)}</td>
                                      <td>{getDateStatusBadge(period)}</td>
                                      <td>
                                        <div className="fw-bold">{formatCurrency(period.montant_initial)}</div>
                                        {period.montant_paye > 0 && <small className="text-success d-block">Déjà payé: {formatCurrency(period.montant_paye)}</small>}
                                      </td>
                                      <td>
                                        {period.interest > 0 ? <Badge bg="warning" className="px-3 py-2">{formatCurrency(period.interest || 0)}</Badge> : <span className="text-muted">-</span>}
                                      </td>
                                      <td>
                                        <h5 className="text-danger mb-0">{formatCurrency(period.montant_restant)}</h5>
                                        <small className="text-muted">{Math.round(period.payment_percentage)}% payé</small>
                                        </td>
                                      <td className="text-end">
                                        <div className="d-flex justify-content-end gap-2">
                                          <Button 
                                            variant="danger" 
                                            size="sm" 
                                            onClick={() => handleCollectPayment(period)} 
                                            className="d-flex align-items-center"
                                          >
                                            <Cash className="me-1" />Collecter
                                          </Button>
                                          <OverlayTrigger placement="top" overlay={<Tooltip>Voir détails</Tooltip>}>
                                            <Button variant="outline-primary" size="sm" onClick={() => handleViewDetails(period)}>
                                              <Eye size={14} />
                                            </Button>
                                          </OverlayTrigger>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                            
                            {/* Pagination */}
                            {totalPages > 1 && (
                              <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                                <div className="text-muted small">
                                  Affichage de {((currentPage - 1) * itemsPerPage) + 1} à {Math.min(currentPage * itemsPerPage, totalItems)} sur {totalItems} échéances
                                </div>
                                <Pagination size="sm" className="mb-0">
                                  <Pagination.Prev 
                                    disabled={currentPage === 1} 
                                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                  />
                                  {[...Array(Math.min(5, totalPages))].map((_, index) => {
                                    let pageNum;
                                    if (totalPages <= 5) {
                                      pageNum = index + 1;
                                    } else if (currentPage <= 3) {
                                      pageNum = index + 1;
                                      if (index === 4) pageNum = '...';
                                    } else if (currentPage >= totalPages - 2) {
                                      pageNum = totalPages - 4 + index;
                                      if (index === 0 && pageNum > 1) pageNum = '...';
                                    } else {
                                      pageNum = currentPage - 2 + index;
                                      if (index === 0 && pageNum > 1) pageNum = '...';
                                      if (index === 4 && pageNum < totalPages) pageNum = '...';
                                    }
                                    
                                    if (pageNum === '...') {
                                      return <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />;
                                    }
                                    
                                    return (
                                      <Pagination.Item
                                        key={pageNum}
                                        active={pageNum === currentPage}
                                        onClick={() => setCurrentPage(pageNum)}
                                      >
                                        {pageNum}
                                      </Pagination.Item>
                                    );
                                  })}
                                  <Pagination.Next 
                                    disabled={currentPage === totalPages} 
                                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                  />
                                </Pagination>
                              </div>
                            )}
                            
                            {searchTerm && (
                              <div className="mt-3 text-center">
                                <small className="text-muted">
                                  {totalItems} résultat(s) trouvé(s) pour "{searchTerm}"
                                </small>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </Tab>
                    
                    <Tab 
                      eventKey="upcoming" 
                      title={
                        <div className="d-flex align-items-center px-3 py-2">
                          <HourglassSplit className="me-2 text-warning" />
                          <span>En attente</span>
                          {stats.upcomingCount > 0 && <Badge bg="warning" className="ms-2">{stats.upcomingCount}</Badge>}
                        </div>
                      }
                    >
                      <div className="pt-3">
                        {upcomingPeriods.length === 0 ? (
                          <div className="text-center py-5"><HourglassSplit size={48} className="text-warning mb-3 opacity-50" /><p className="text-muted">Aucune échéance en attente</p></div>
                        ) : (
                          <div className="table-responsive">
                            <Table hover className="table-custom">
                              <thead className="table-light">
                                <tr>
                                  <th onClick={() => requestSort('period_label')} style={{ cursor: 'pointer' }}>Période</th>
                                  <th onClick={() => requestSort('due_date')} style={{ cursor: 'pointer' }}>Échéance</th>
                                  <th>Statut Paiement</th>
                                  <th>Statut Date</th>
                                  <th onClick={() => requestSort('montant_initial')} style={{ cursor: 'pointer' }}>Montant initial</th>
                                  <th>Jours restants</th>
                                  <th onClick={() => requestSort('montant_restant')} style={{ cursor: 'pointer' }}>Restant à payer</th>
                                  <th className="text-end">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paginatedPeriods.map((period) => {
                                  const daysRemaining = Math.ceil((new Date(period.due_date) - new Date()) / (1000 * 60 * 60 * 24));
                                  return (
                                    <tr key={period.id} className="align-middle">
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                                            {getStatusIcon(getPaymentStatus(period))}
                                          </div>
                                          <div>
                                            <div className="fw-medium">{period.period_label}</div>
                                            <small className="text-muted">Année {period.year}</small>
                                          </div>
                                        </div>
                                        </td>
                                      <td><div className="fw-medium">{formatDate(period.due_date)}</div></td>
                                      <td>{getPaymentStatusBadge(period)}</td>
                                      <td>{getDateStatusBadge(period)}</td>
                                      <td>
                                        <div className="fw-bold">{formatCurrency(period.montant_initial)}</div>
                                        {period.montant_paye > 0 && <small className="text-success d-block">Déjà payé: {formatCurrency(period.montant_paye)}</small>}
                                        </td>
                                      <td><Badge bg={daysRemaining <= 30 ? "warning" : "info"} className="px-3 py-2">{daysRemaining} jours</Badge></td>
                                      <td>
                                        <h5 className="text-danger mb-0">{formatCurrency(period.montant_restant)}</h5>
                                        <small className="text-muted">{Math.round(period.payment_percentage)}% payé</small>
                                        </td>
                                      <td className="text-end">
                                        <Button 
                                          variant="warning" 
                                          size="sm" 
                                          onClick={() => handleCollectPayment(period)} 
                                          className="d-flex align-items-center"
                                        >
                                          <Cash className="me-1" />Collecter
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        )}
                      </div>
                    </Tab>

                    <Tab 
                      eventKey="paid" 
                      title={
                        <div className="d-flex align-items-center px-3 py-2">
                          <CheckCircle className="me-2 text-success" />
                          <span>Soldées</span>
                          {stats.paidCount > 0 && <Badge bg="success" className="ms-2">{stats.paidCount}</Badge>}
                        </div>
                      }
                    >
                      <div className="pt-3">
                        {paidPeriods.length === 0 ? (
                          <div className="text-center py-5"><CheckCircle size={48} className="text-success mb-3 opacity-50" /><p className="text-muted">Aucune échéance soldée</p></div>
                        ) : (
                          <div className="table-responsive">
                            <Table hover className="table-custom">
                              <thead className="table-light">
                                <tr>
                                  <th onClick={() => requestSort('period_label')} style={{ cursor: 'pointer' }}>Période</th>
                                  <th onClick={() => requestSort('due_date')} style={{ cursor: 'pointer' }}>Échéance</th>
                                  <th>Statut Paiement</th>
                                  <th>Montant initial</th>
                                  <th onClick={() => requestSort('montant_paye')} style={{ cursor: 'pointer' }}>Montant payé</th>
                                  <th>Progression</th>
                                  <th className="text-end">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paginatedPeriods.map((period) => (
                                  <tr key={period.id} className="align-middle">
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                                          {getStatusIcon(getPaymentStatus(period))}
                                        </div>
                                        <div>
                                          <div className="fw-medium">{period.period_label}</div>
                                          <small className="text-muted">Année {period.year}</small>
                                        </div>
                                      </div>
                                      </td>
                                    <td><div className="fw-medium">{formatDate(period.due_date)}</div></td>
                                    <td>{getPaymentStatusBadge(period)}</td>
                                    <td><div className="fw-bold">{formatCurrency(period.montant_initial)}</div></td>
                                    <td>
                                      <h5 className="text-success mb-0">{formatCurrency(period.montant_paye)}</h5>
                                      <small className="text-muted">{Math.round(period.payment_percentage)}% du total</small>
                                      </td>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <ProgressBar now={100} variant="success" className="flex-grow-1 me-2" style={{ height: '8px' }} />
                                        <span className="fw-medium">{100}%</span>
                                      </div>
                                      </td>
                                    <td className="text-end">
                                      <div className="d-flex justify-content-end gap-2">
                                        {/* <OverlayTrigger placement="top" overlay={<Tooltip>Imprimer reçu PDF</Tooltip>}>
                                          <Button variant="outline-success" size="sm" onClick={() => generateBordereauPaiement(period)}>
                                            <Printer size={14} className="me-1" /> PDF
                                          </Button>
                                        </OverlayTrigger> */}
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Voir détails</Tooltip>}>
                                          <Button variant="outline-primary" size="sm" onClick={() => handleViewDetails(period)}>
                                            <Eye size={14} />
                                          </Button>
                                        </OverlayTrigger>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                  
                  <Card className="border-0 bg-light">
                    <Card.Body className="p-3">
                      <Row className="align-items-center">
                        <Col md={6}>
                          <div className="d-flex align-items-center">
                            <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3"><Calculator size={24} className="text-primary" /></div>
                            <div>
                              <h6 className="mb-1">Résumé des montants</h6>
                              <small className="text-muted">
                                Total initial: <strong>{formatCurrency(stats.totalInitialAmount)}</strong> • 
                                Impayés: <strong className="text-danger">{formatCurrency(stats.overdueTotal)}</strong> • 
                                En attente: <strong className="text-warning">{formatCurrency(stats.upcomingTotal)}</strong> • 
                                Soldées: <strong className="text-success">{formatCurrency(stats.paidTotal)}</strong>
                              </small>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="text-end">
                          <div className="d-flex flex-column align-items-end">
                            <div className="mb-1">
                              <small className="text-muted">Total échéances: </small>
                              <strong>{stats.totalCount}</strong>
                            </div>
                            <div>
                              <small className="text-muted">Progression globale: </small>
                              <strong className="text-success">
                                {stats.totalInitialAmount > 0 ? Math.round((stats.paidTotal / stats.totalInitialAmount) * 100) : 0}%
                              </strong>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
      
      {/* Modal de détails de la période */}
      <Modal show={showDetailsPeriodModal} onHide={() => setShowDetailsPeriodModal(false)} centered size="lg">
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title className="d-flex align-items-center"><Eye className="me-2" size={20} />Détails de l'échéance</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          {selectedDetailPeriod && (
            <>
              <div className="text-center mb-4">
                <h4 className="fw-bold mb-2">{selectedDetailPeriod.period_label}</h4>
                <div className="d-flex justify-content-center gap-2">
                  {getPaymentStatusBadge(selectedDetailPeriod)}
                  {getDateStatusBadge(selectedDetailPeriod)}
                </div>
              </div>
              <Row className="g-3">
                <Col md={6}>
                  <Card className="border-0 shadow-sm h-100">
                    <Card.Body>
                      <h6 className="text-muted mb-3">Informations générales</h6>
                      <div className="mb-2">
                        <small className="text-muted">Date d'échéance</small>
                        <div className="fw-semibold">{formatDate(selectedDetailPeriod.due_date)}</div>
                      </div>
                      <div className="mb-2">
                        <small className="text-muted">Année</small>
                        <div className="fw-semibold">{selectedDetailPeriod.year}</div>
                      </div>
                      {selectedDetailPeriod.days_late > 0 && (
                        <div className="mb-2">
                          <small className="text-muted">Jours de retard</small>
                          <div className="fw-semibold text-danger">{selectedDetailPeriod.days_late} jours</div>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="border-0 shadow-sm h-100">
                    <Card.Body>
                      <h6 className="text-muted mb-3">Montants</h6>
                      <div className="mb-2">
                        <small className="text-muted">Montant initial</small>
                        <div className="fw-semibold">{formatCurrency(selectedDetailPeriod.montant_initial)}</div>
                      </div>
                      <div className="mb-2">
                        <small className="text-muted">Déjà payé</small>
                        <div className="fw-semibold text-success">{formatCurrency(selectedDetailPeriod.montant_paye)}</div>
                      </div>
                      <div className="mb-2">
                        <small className="text-muted">Reste à payer</small>
                        <div className="fw-semibold text-danger">{formatCurrency(selectedDetailPeriod.montant_restant)}</div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={12}>
                  <Card className="border-0 shadow-sm">
                    <Card.Body>
                      <h6 className="text-muted mb-3">Progression du paiement</h6>
                      <div className="d-flex align-items-center mb-2">
                        <ProgressBar 
                          now={selectedDetailPeriod.payment_percentage} 
                          variant={getPaymentStatus(selectedDetailPeriod) === 'payee' ? "success" : getPaymentStatus(selectedDetailPeriod) === 'partiel' ? "warning" : "danger"} 
                          className="flex-grow-1 me-3" 
                          style={{ height: '10px' }} 
                        />
                        <span className="fw-bold">{Math.round(selectedDetailPeriod.payment_percentage)}%</span>
                      </div>
                      <div className="d-flex justify-content-between text-muted small">
                        <span>Payé: {formatCurrency(selectedDetailPeriod.montant_paye)}</span>
                        <span>Restant: {formatCurrency(selectedDetailPeriod.montant_restant)}</span>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={12}>
                  <Card className="border-0 shadow-sm">
                    <Card.Body>
                      <h6 className="text-muted mb-3">Informations techniques</h6>
                      <Row>
                        <Col md={6}>
                          <small className="text-muted">ID Échéance</small>
                          <div><code>{selectedDetailPeriod.echeance_id || selectedDetailPeriod.id}</code></div>
                        </Col>
                        <Col md={6}>
                          <small className="text-muted">ID Taxe</small>
                          <div><code>{selectedDetailPeriod.taxe_id || 'N/A'}</code></div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailsPeriodModal(false)}>Fermer</Button>
          {/* {selectedDetailPeriod && (getPaymentStatus(selectedDetailPeriod) === 'payee' || getPaymentStatus(selectedDetailPeriod) === 'partiel') && (
            <Button variant="primary" onClick={() => { setShowDetailsPeriodModal(false); generateBordereauPaiement(selectedDetailPeriod); }}>
              <Printer className="me-2" />Imprimer reçu PDF
            </Button>
          )} */}
        </Modal.Footer>
      </Modal>
      
      <Footer />
      
      <style>{`
        .text-gradient-primary {
          background: linear-gradient(135deg, #0d6efd 0%, #6610f2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .card-header-gradient {
          height: 6px;
          width: 100%;
          background: linear-gradient(90deg, #0d6efd 0%, #20c997 100%);
        }
        .avatar-xl {
          width: 80px;
          height: 80px;
          border: 3px solid rgba(13, 110, 253, 0.1);
        }
        .icon-statistic {
          background: rgba(255, 255, 255, 0.2);
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .statistic-wave {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 100px;
          height: 100px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          transform: translate(30%, 30%);
        }
        .table-custom th {
          border-top: none;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 0.85rem;
          color: #6c757d;
          letter-spacing: 0.5px;
          background-color: #f8f9fa;
        }
        .table-custom td {
          vertical-align: middle;
          padding: 1rem 0.75rem;
        }
        .table-custom tbody tr:hover {
          background-color: rgba(13, 110, 253, 0.05);
        }
        .cursor-pointer {
          cursor: pointer;
        }
        .bg-primary-subtle {
          background-color: rgba(13, 110, 253, 0.1) !important;
        }
        .breadcrumb-arrow {
          --bs-breadcrumb-divider: '›';
        }
        @media (max-width: 768px) {
          .avatar-xl { width: 60px; height: 60px; }
          .icon-statistic { width: 40px; height: 40px; }
          .table-custom { display: block; overflow-x: auto; }
        }
      `}</style>
    </>
  );
};

export default EcheancesTaxPage;